module.exports = __webpack_public_path__ + "static/media/Software.f948a00a.md";